<template>
  <div>

    <div>
      <div class="mt-6 -mb-1 flex flex-wrap">
        <template v-for="(link, key) in paginationLinks">
          <div v-if="link.url === null" :key="key" class="mr-1 mb-1 px-4 py-3 text-sm border rounded text-gray-400" :class="{ 'ml-auto': link.label === 'Next' }">{{ link.label }}</div>
          <a v-else :key="key" class="mr-1 mb-1 px-4 py-3 text-sm border rounded hover:bg-white focus:border-indigo-500 focus:text-indigo-500" :class="{ 'bg-white': link.active, 'ml-auto': link.label === 'Next' }" @click="() => loadPageUrl(link)">{{ link.label }}</a>
        </template>
      </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-4">
      <div v-for="product in products" :key="`p-${product.id}-${unit[product.id]}`" class="w-full p-2">
         <product-item-card :product="product"
                            :is-customer="isCustomer"
                            :display-item-price="$page.props.display_item_price"
                            :enable-product-unit-selection="enableProductUnitSelection" />
      </div>
    </div>

    <div>
      <div class="mt-6 -mb-1 flex flex-wrap">
        <template v-for="(link, key) in paginationLinks">
          <div v-if="link.url === null" :key="key" class="mr-1 mb-1 px-4 py-3 text-sm border rounded text-gray-400" :class="{ 'ml-auto': link.label === 'Next' }">{{ link.label }}</div>
          <a v-else :key="key" class="mr-1 mb-1 px-4 py-3 text-sm border rounded hover:bg-white focus:border-indigo-500 focus:text-indigo-500" :class="{ 'bg-white': link.active, 'ml-auto': link.label === 'Next' }" @click="() => loadPageUrl(link)">{{ link.label }}</a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import Pagination from '@/Shared/Pagination'
  import ProductItemCard from '@/Shared/ProductItemCard'
  export default {
  name: 'ProductCatalog',
  components: {ProductItemCard, Pagination},
  // components: {Icon},

  props: {
    selectedItems: {
      type: Array,
    },
    location: String,
    enableProductUnitSelection: {
      type: Boolean,
      default: false,
    },
    searchText: String,
    priceGroup: String,
    isCustomer: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      // qty: [],
      unit: [],
      products: [],
      paginationLinks: [],
      search: null,
      page: 1,
      pageSize: 28,
    }
  },

  watch: {
    search: _.debounce(function (value) {
      this.searchProduct(value)
    }, 500),

    'searchText' : function(val) {
      this.search = val
    },

    location: function() {
      this.$emit('locationChanged')
      this.fetchProducts()
    },

    priceGroup: function() {
      this.$emit('locationChanged')
      this.fetchProducts()
    },
  },

  mounted() {
    this.fetchProducts()
  },

  methods: {

    syncKeyword: _.debounce(function (event) {
      this.search = event.target.value
    }, 200),

    fetchProducts(queryStringEnd = '') {
      if(this.location) {
        this.$http.get(this.route('admin.product_catalog')+'?per_page=28&location='+this.location +'&pg='+ this.priceGroup + queryStringEnd).then(response => {
          this.products = response.data.data
          this.paginationLinks = response.data.links
        })
      }
    },

    loadPageUrl(Link) {
      if(this.location) {
        this.$http.get(Link.url).then(response => {
          this.products = response.data.data
          this.paginationLinks = response.data.links
        })
      }
    },

    searchProduct(searchTerm) {
      if(searchTerm) {
        this.fetchProducts('&search='+searchTerm);
      } else {
        this.fetchProducts();
      }
    },

    // fetchProducts() {
    //   if(this.location) {
    //     this.$http.get(this.route('lists.products')+'?location='+this.location).then(response => {
    //       this.products = response.data
    //     })
    //   }
    //
    //
    //     // if (response.data.length) {
    //     //   response.data.forEach(itm => {
    //     //     // this.unit[itm.id] = itm.base_unit
    //     //     // this.qty[itm.id] = 0
    //     //   })
    //     // }
    //
    //
    // },

    // syncProductQty(event) {
    //   if (event.qty === 0) {
    //     this.$emit('remove-item-of', {
    //       product: event.product,
    //       qty: event.qty,
    //       unit: event.unit
    //     })
    //   } else {
    //     this.$emit('add-item-of', {
    //       product: event.product,
    //       qty: event.qty,
    //       unit: event.unit
    //     })
    //   }
    // },

    // nextPage() {
    //   if (this.page < this.totalPages) {
    //     this.page = this.page+1
    //   }
    // },
    //
    // prevPage() {
    //   if (this.page > 1) {
    //     this.page = this.page-1
    //   }
    // },

    // quantityAdded(item_code, unit) {
    //   let item = this.selectedItems.find(itm => itm.product.item_code === item_code && itm.unit === unit)
    //
    //   if (item) {
    //     return item.qty
    //   } else {
    //     return 0
    //   }
    // },
  },

  computed: {

    // paginated() {
    //   let start = ((this.page -1) * this.pageSize)
    //
    //   return this.items.slice(start, start + this.pageSize)
    // },
    //
    // from() {
    //   if (this.items.length === 0 ) {
    //     return 0
    //   }
    //   return ((this.page - 1) * this.pageSize) + 1
    // },
    //
    // to() {
    //   let offset = this.page * this.pageSize
    //
    //   return offset > this.items.length ? this.items.length : offset
    // },
    //
    // items() {
    //
    //   let products = this.products
    //
    //   // ignore already selected items
    //   // products =  products.filter(itm => this.selectedItems.indexOf(itm.id) === -1)
    //
    //   if (this.search !== '' && this.search !== null) {
    //
    //     const options = {
    //       location:0,
    //       threshold: 0.3,
    //       distance: 100,
    //       keys: [
    //         'description',
    //         'brand',
    //       ],
    //     };
    //
    //     let fuse = new Fuse(products, options)
    //
    //     return fuse.search(`${this.search}`).map(itm => itm.item).sort(function (a, b) {
    //       return b.available - a.available;
    //     });
    //     // products = products.filter(itm => itm.description.toLowerCase().includes(this.search.toLowerCase())).sort(itm => !itm.available)
    //   }
    //
    //   return products
    // },
    //
    // totalPages() {
    //   return Math.ceil(this.items.length / this.pageSize)
    // },
  },
}
</script>

